import { render, staticRenderFns } from "./SwitchPlayer.vue?vue&type=template&id=060a916e&"
import script from "./SwitchPlayer.vue?vue&type=script&lang=js&"
export * from "./SwitchPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports